function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "4a269173fa"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "748acdc2af"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 187.5 37.5 C 104.65625 37.5 37.5 104.65625 37.5 187.5 C 37.5 270.34375 104.65625 337.5 187.5 337.5 C 270.34375 337.5 337.5 270.34375 337.5 187.5 C 337.5 104.65625 270.34375 37.5 187.5 37.5 Z M 187.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "1db6053e3d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 127 146 L 255 146 L 255 249 L 127 249 Z M 127 146 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "215c03624c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "3e33cf7db6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "63d82e99e6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 214 189 L 224 189 L 224 203 L 214 203 Z M 214 189 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b192284f9b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "31a832225d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "1d80f9d176"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 206 170 L 216 170 L 216 185 L 206 185 Z M 206 170 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "f23ffed65b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d8aa7fa4a5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ff9f7038f8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 137 120 L 208 120 L 208 182 L 137 182 Z M 137 120 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d37f06a053"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d55f48d938"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "24878c7ad3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 114 194 L 137 194 L 137 220 L 114 220 Z M 114 194 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bdab22338b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "5c261d9196"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "f32d43530d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 177 150 L 187 150 L 187 159 L 177 159 Z M 177 150 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "024a431c85"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "017ae7b299"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 131.1875 110.273438 L 267.015625 134.671875 L 243.675781 264.59375 L 107.851562 240.191406 Z M 131.1875 110.273438 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#4a269173fa)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#748acdc2af)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  transform: "matrix(0.75, 0, 0, 0.75, 37.500002, 37.499998)",
  fill: "none",
  strokeLinejoin: "miter",
  d: "M 200.00001 0.00000328333 C 89.54167 0.00000328333 -0.00000271667 89.541676 -0.00000271667 200.000016 C -0.00000271667 310.458357 89.54167 400.00003 200.00001 400.00003 C 310.458351 400.00003 400.000024 310.458357 400.000024 200.000016 C 400.000024 89.541676 310.458351 0.00000328333 200.00001 0.00000328333 Z M 200.00001 0.00000328333 ",
  stroke: "#ffffff",
  strokeWidth: 36,
  strokeOpacity: 1,
  strokeMiterlimit: 4
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#1db6053e3d)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#215c03624c)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#3e33cf7db6)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 144.785156 225.535156 C 143.230469 226.199219 142.515625 227.996094 143.175781 229.546875 L 150.460938 246.558594 C 150.777344 247.304688 151.378906 247.890625 152.132812 248.195312 C 152.328125 248.269531 152.527344 248.328125 152.726562 248.363281 C 153.3125 248.46875 153.917969 248.402344 154.46875 248.164062 L 252.757812 206.089844 C 253.503906 205.769531 254.089844 205.167969 254.394531 204.417969 C 254.691406 203.664062 254.683594 202.824219 254.367188 202.078125 L 247.082031 185.066406 C 246.761719 184.320312 246.160156 183.730469 245.410156 183.429688 C 244.65625 183.132812 243.816406 183.140625 243.070312 183.460938 C 241.660156 184.0625 240.121094 184.238281 238.621094 183.96875 C 236.015625 183.5 233.839844 181.773438 232.800781 179.347656 C 231.105469 175.378906 232.949219 170.773438 236.914062 169.078125 C 237.660156 168.757812 238.246094 168.15625 238.546875 167.40625 C 238.847656 166.652344 238.839844 165.8125 238.523438 165.066406 L 231.238281 148.054688 C 230.574219 146.503906 228.78125 145.785156 227.226562 146.449219 L 128.9375 188.523438 C 127.386719 189.1875 126.667969 190.984375 127.332031 192.535156 L 134.613281 209.546875 C 134.933594 210.292969 135.535156 210.878906 136.289062 211.183594 C 137.039062 211.480469 137.878906 211.472656 138.625 211.15625 C 140.039062 210.550781 141.578125 210.375 143.078125 210.644531 C 145.683594 211.109375 147.855469 212.839844 148.894531 215.265625 C 150.59375 219.230469 148.75 223.839844 144.785156 225.535156 Z M 144.15625 204.628906 C 142.496094 204.332031 140.804688 204.339844 139.164062 204.644531 L 134.152344 192.9375 L 202.652344 163.613281 L 203.253906 165.015625 C 203.570312 165.753906 204.222656 166.238281 204.957031 166.371094 C 205.382812 166.449219 205.835938 166.40625 206.261719 166.222656 C 207.425781 165.722656 207.964844 164.378906 207.46875 163.214844 L 206.867188 161.808594 L 226.824219 153.265625 L 231.835938 164.972656 C 226.667969 168.703125 224.574219 175.652344 227.183594 181.75 C 229.035156 186.074219 232.90625 189.152344 237.539062 189.984375 C 239.203125 190.28125 240.890625 190.273438 242.535156 189.96875 L 247.546875 201.675781 L 227.589844 210.21875 L 226.988281 208.816406 C 226.488281 207.652344 225.144531 207.117188 223.980469 207.609375 C 222.816406 208.109375 222.277344 209.453125 222.773438 210.617188 L 223.375 212.023438 L 154.875 241.347656 L 149.863281 229.640625 C 155.027344 225.910156 157.121094 218.960938 154.511719 212.863281 C 152.660156 208.539062 148.789062 205.460938 144.15625 204.628906 Z M 144.15625 204.628906 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}))));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#63d82e99e6)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b192284f9b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#31a832225d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 218.871094 201.496094 C 219.1875 202.234375 219.839844 202.71875 220.574219 202.851562 C 221 202.925781 221.453125 202.882812 221.878906 202.703125 C 223.042969 202.203125 223.582031 200.855469 223.085938 199.691406 L 219.179688 190.574219 C 218.679688 189.410156 217.332031 188.875 216.171875 189.367188 C 215.007812 189.867188 214.46875 191.214844 214.964844 192.378906 Z M 218.871094 201.496094 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}))));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#1d80f9d176)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f23ffed65b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d8aa7fa4a5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 211.0625 183.257812 C 211.378906 183.992188 212.03125 184.480469 212.765625 184.609375 C 213.191406 184.6875 213.644531 184.644531 214.070312 184.460938 C 215.234375 183.960938 215.773438 182.617188 215.273438 181.453125 L 211.371094 172.332031 C 210.875 171.167969 209.527344 170.632812 208.363281 171.128906 C 207.199219 171.628906 206.660156 172.972656 207.160156 174.136719 Z M 211.0625 183.257812 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}))));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ff9f7038f8)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d37f06a053)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d55f48d938)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 204.199219 138.117188 C 205.304688 136.84375 205.171875 134.914062 203.894531 133.808594 L 189.917969 121.679688 C 188.648438 120.578125 186.734375 120.710938 185.625 121.964844 C 185.324219 122.304688 155.34375 156.304688 137.851562 176.457031 C 136.746094 177.730469 136.882812 179.660156 138.15625 180.765625 C 138.589844 181.136719 139.09375 181.371094 139.617188 181.464844 C 140.640625 181.648438 141.734375 181.304688 142.46875 180.460938 C 150.632812 171.054688 161.519531 158.628906 170.835938 148.019531 L 171.636719 148.710938 C 171.960938 148.992188 172.335938 149.167969 172.730469 149.238281 C 173.5 149.375 174.316406 149.117188 174.867188 148.484375 C 175.699219 147.527344 175.59375 146.082031 174.640625 145.25 L 173.863281 144.578125 C 180.175781 137.394531 185.46875 131.382812 188.203125 128.28125 L 197.835938 136.640625 C 196.644531 138.84375 196.09375 141.332031 196.214844 143.882812 C 196.210938 143.910156 196.214844 143.933594 196.214844 143.960938 C 196.222656 144.074219 196.207031 144.1875 196.214844 144.300781 C 196.21875 144.335938 196.230469 144.371094 196.234375 144.40625 C 196.238281 144.445312 196.234375 144.480469 196.242188 144.519531 C 196.890625 148.867188 199.125 152.25 202.535156 154.039062 C 202.820312 154.1875 203.117188 154.289062 203.417969 154.34375 C 204.695312 154.570312 206.027344 153.964844 206.660156 152.753906 C 207.445312 151.257812 206.871094 149.414062 205.375 148.628906 C 203.765625 147.785156 202.683594 146.054688 202.3125 143.753906 C 202.175781 141.683594 202.839844 139.683594 204.199219 138.117188 Z M 204.199219 138.117188 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}))));
var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#24878c7ad3)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bdab22338b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#5c261d9196)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 125.683594 195.257812 C 124.40625 194.148438 122.476562 194.289062 121.371094 195.5625 C 118.714844 198.625 115.554688 202.683594 115.425781 202.855469 C 114.429688 204.136719 114.609375 205.972656 115.832031 207.039062 L 129.8125 219.167969 C 130.230469 219.53125 130.738281 219.773438 131.273438 219.867188 C 131.523438 219.914062 131.773438 219.925781 132.03125 219.910156 C 132.839844 219.851562 133.59375 219.476562 134.125 218.863281 C 134.558594 218.359375 135.054688 217.914062 135.597656 217.542969 C 136.988281 216.585938 137.339844 214.683594 136.382812 213.292969 C 135.425781 211.902344 133.527344 211.554688 132.132812 212.507812 C 132.007812 212.59375 131.886719 212.683594 131.765625 212.773438 L 122.042969 204.335938 C 123.171875 202.925781 124.664062 201.09375 125.988281 199.566406 C 127.09375 198.292969 126.957031 196.363281 125.683594 195.257812 Z M 125.683594 195.257812 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}))));
var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f32d43530d)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#024a431c85)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#017ae7b299)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 180.15625 150.039062 L 177.109375 153.460938 C 177.109375 153.460938 181.695312 157.546875 182.558594 158.296875 C 182.882812 158.578125 183.261719 158.75 183.65625 158.820312 C 184.421875 158.960938 185.242188 158.699219 185.792969 158.066406 C 186.621094 157.113281 186.519531 155.664062 185.5625 154.835938 C 184.703125 154.089844 180.15625 150.042969 180.15625 150.039062 Z M 180.15625 150.039062 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}))));
function SvgIcono2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono2);
export default __webpack_public_path__ + "static/media/icono2.d7945b122632523515e08077a36ddf83.svg";
export { ForwardRef as ReactComponent };